import React, {useState} from "react";
import useAlphabeticInput from "../hooks/useAlphabeticInput";
import useNumericInput from "../hooks/useNumericInput";
import { showSuccess, showError } from "../utils/toastUtils";
import contactFormAPI from "../api/contactForm";


const ContactForm = () => {
  useAlphabeticInput();
  useNumericInput();

  const INITIAL_FORM_DATA = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please enter email address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter phone";
    }

    if (!formData.name.trim()) {
      newErrors.name = "Please enter name";
    }
    if (!formData.subject.trim()) {
      newErrors.subject = "Please enter subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Please enter message";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setLoading(true);
    try {
      const res = await contactFormAPI.contact_form(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData(INITIAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <input
              type="text"
              name="name"
              className="form-control only-alphabets"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="text-danger">{errors.name}</span>}
          </div>
          <div className="col-md-6">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && (
              <span className="text-danger">{errors.email}</span>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="phone"
              maxLength={10}
              className="form-control only-numeric"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            {errors.phone && (
              <span className="text-danger">{errors.phone}</span>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="subject"
              className="form-control only-alphabets"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
            />
            {errors.subject && (
              <span className="text-danger">{errors.subject}</span>
            )}
          </div>
          <div className="col-12">
            <textarea
              name="message"
              rows={5}
              className="form-control"
              placeholder="Message"
              defaultValue={""}
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && (
              <span className="text-danger">{errors.message}</span>
            )}
          </div>
          <div className="col-12">
            <button className="mrv-btn-outline">Send Message</button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
